import './DeliveryInfo.css';
import { useMemo, useState } from 'react';
import { DELIVERY_TYPE_VALUES, NO_DELIVERY_TYPE } from '../../../../../assets/utils/constants';
import { formatAddress, parsePrice } from '../../../../../assets/utils/utils';
import DeliveryMapPopup from './DeliveryMapPopup/DeliveryMapPopup';

function DeliveryInfo({
    order,
}) {
    const [isMapOpen, setIsMapOpen] = useState(false);

    const deliveryData = order?.delivery_data || {};
    const additional = deliveryData?.additional_address_data || {};
    const coords = deliveryData?.coords;
    const hasCoords = Array.isArray(coords) && coords.length === 2;

    const deliveryType = order?.delivery_type
    const deliveryTypeLabel = DELIVERY_TYPE_VALUES[deliveryType] || 'Доставка';
    const deliveryPriceLabel = order?.delivery_price !== undefined && order?.delivery_price !== null
        ? parsePrice(order.delivery_price, 'RUB')
        : null;


    const fallbackAddress = useMemo(() => {
        if (order?.address) {
            return typeof order.address === 'string'
                ? order.address
                : formatAddress(order.address);
        }
        return 'Адрес не указан';
    }, [order]);

    const formattedAddress = deliveryData?.address || fallbackAddress;

    const extraDetails = useMemo(() => ([
        { label: 'Квартира', value: additional?.apartment },
        { label: 'Подъезд', value: additional?.entrance },
        { label: 'Домофон', value: additional?.entry_code },
        { label: 'Этаж', value: additional?.floor },
    ].filter((item) => item.value)), [additional]);

    return (
        <>
            <div
                className={`delivery-info`}
                key={`delivery-info-${order?._id}`}
            >
                <header className="delivery-info__header">
                    <div className="delivery-info__title-block">
                        <span className="delivery-info__label">Способ получения</span>
                        <p className="delivery-info__title">
                            {deliveryTypeLabel}
                        </p>
                    </div>
                    <div className="delivery-info__chips">
                        {deliveryPriceLabel ? (
                            <span className="delivery-info__pill delivery-info__pill_accent">
                                {deliveryPriceLabel}
                            </span>
                        ) : null}
                    </div>
                </header>

                {deliveryType !== NO_DELIVERY_TYPE ?
                    <div className="delivery-info__body">
                        <div className="delivery-info__row">
                            <span className="delivery-info__label">Адрес</span>
                            <p className="delivery-info__value">
                                {formattedAddress}
                            </p>
                        </div>

                        {extraDetails.length > 0 ? (
                            <div className="delivery-info__grid">
                                {extraDetails.map((item) => (
                                    <div className="delivery-info__col" key={`delivery-${item.label}`}>
                                        <span className="delivery-info__label">{item.label}</span>
                                        <span className="delivery-info__value">{item.value}</span>
                                    </div>
                                ))}
                            </div>
                        ) : null}

                        {additional?.comment ? (
                            <div className="delivery-info__row">
                                <span className="delivery-info__label">Комментарий</span>
                                <p className="delivery-info__value delivery-info__value_muted">
                                    {additional.comment}
                                </p>
                            </div>
                        ) : null}

                        {order?.delivery_time?.title?.ru ? (
                            <div className="delivery-info__row">
                                <span className="delivery-info__label">Срок</span>
                                <p className="delivery-info__value delivery-info__value_muted">
                                    {order?.delivery_time?.title?.ru}
                                </p>
                            </div>
                        ) : null}
                    </div>
                    : null}

                {deliveryType !== NO_DELIVERY_TYPE ?
                    <div className="delivery-info__footer">
                        {hasCoords ? (
                            <button
                                type="button"
                                className="delivery-info__map-btn"
                                onClick={() => setIsMapOpen(true)}
                            >
                                Показать на карте
                            </button>
                        ) : (
                            <span className="delivery-info__hint">Координаты для карты недоступны</span>
                        )}
                    </div>
                    : null}
            </div>

            {hasCoords ? (
                <DeliveryMapPopup
                    isOpen={isMapOpen}
                    address={formattedAddress}
                    coords={coords}
                    onClose={() => setIsMapOpen(false)}
                />
            ) : null}
        </>
    );
}

export default DeliveryInfo


